<template>
  <div class="three-state-selector">
    <b-form-select 
      v-model="selected" 
      :options="options"
      @change="$emit('inputChanged', $event)"
      :class="inputClasses" 
    >
    </b-form-select>
  </div>
</template>

<script>
import { inputClassList } from '@/mixins/inputClassList.js'

export default {
  name: 'three-state-selector',
  mixins: [inputClassList],
  data() {
    return {
      selected: null
    }
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Number,
      required: false,
      default: null
    },
    isValidField: {
      type: Boolean,
      required: false,
      default: true
    },
    isRecommendedField: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  mounted() {
    if (this.value) {
      this.selected = +this.value
    }
  }
}
</script>

<style scoped>
/*** Component Style ***/
.three-state-selector {
  position: relative;
}
</style>